<section class="seller-container">
  <section class="ids-mv-4 ids-pt-8">
    <form [formGroup]="formStepTwo" autocomplete="off">
      <h2 class="ids-text-title-01">dados dos representantes</h2>
      <p class="ids-pv-4">pessoas designadas pela empresa para assinatura do contrato</p>
      <app-seller-represent-pj
        [formStep]="formStepTwo"
        [dataCompany]="dataCompany"
        (currentRepresents)="reciveCurrentRepresents($event)"
      >
      </app-seller-represent-pj>

      <app-seller-procurator-pj [formStepProcurator]="formStepTwo"
                                [dataCompany]="dataCompany"
                                (currentProcurators)="reciveCurrentProcurator($event)"></app-seller-procurator-pj>
    </form>
  </section>
</section>
